import ConnectWithoutContactOutlinedIcon from '@mui/icons-material/ConnectWithoutContactOutlined';
import { SvgIconProps } from '@mui/material';

export const ICOMX_OPEN_COMMUNICATIONS_LABEL = 'Open iComx communications';
export const ICOMX_DISABLED_COMMUNICATIONS_LABEL =
  'iComx requires linked FHIR resource data and a phone or email.';

export default function IcomxCommunicationIcon(props: SvgIconProps) {
  return <ConnectWithoutContactOutlinedIcon {...props} />;
}
